/* eslint-disable no-alert */
import React from 'react'
import { connect } from 'react-redux'
import { Tab, Grid } from 'semantic-ui-react'
import HasuraOrderActions from '../../../reducers/hasuraOrderReducer'
import helpers from '../../../utils/helpers'

import FoodAndBeverageReport from './foodAndBeverage'
import ExpressReport from './express'

class SaleReport extends React.PureComponent {
  onTabChange = index => {
    const { history } = this.props
    const tabs = Object.keys(this.tabPanes())
    const queryString = tabs[index] ? `?tab=${tabs[index]}` : ''

    history.push(`/reports/sale${queryString}`)
  }

  tabPanes = () => ({
    'f-and-b': {
      menuItem: 'F & B', render: () => <FoodAndBeverageReport />
    },
    'express': {
      menuItem: 'Express', render: () => <ExpressReport />
    },
  })

  render() {
    const params = helpers.urlParams()
    const tab = params.tab || 'f-and-b'
    const tabIndex = Object.keys(this.tabPanes()).indexOf(tab)

    return (
      <div>
        <Grid columns="equal">
          <Grid.Column grid={16}>
            <Tab
              activeIndex={tabIndex}
              menu={{ pointing: true }}
              panes={Object.values(this.tabPanes())}
              onTabChange={(e, { activeIndex }) => this.onTabChange(activeIndex)}
            />
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapState = ({ hasuraOrders, menus, tags }) => ({
  orders: hasuraOrders.saleReports,
  tags: tags.data,
  menus: menus.data,
  loading: hasuraOrders.loading,

  merchantCategories: hasuraOrders.merchantCategories,
  merchantCategoryLoaded: hasuraOrders.merchantCategoryLoaded,
})

const mapDispatch = {
  fetchOrders: HasuraOrderActions.getSaleReports,
  setOrders: HasuraOrderActions.setSaleReports,
  getMerchantCategories: HasuraOrderActions.getMerchantCategories,
}

export default connect(
  mapState,
  mapDispatch
)(SaleReport)



// WEBPACK FOOTER //
// ./src/containers/reports/sale/index.js